
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import GalleryHero from './components/GalleryHero';
import GalleryGrid from './components/GalleryGrid';
import GalleryContact from './components/GalleryContact';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function GalleryPage() {
  return (
    <div className="min-h-screen bg-neutral-950">
      <Navbar />
      <main>
        <GalleryHero />
        <GalleryGrid />
        <GalleryContact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
